import "core-js/modules/es6.array.map";
import "core-js/modules/es6.object.freeze";
import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/es6.date.to-string";
import "core-js/modules/es6.array.is-array";
import "core-js/modules/es6.function.name";
import "core-js/modules/es6.weak-map";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.string.iterator";
import "core-js/modules/es6.map";
import "core-js/modules/es6.array.reduce";
import { th, system as system$1, compose, space as space$1, typography } from '@xstyled/system';
import { mix, getContrast, modularScale, transparentize, lighten, darken, normalize } from 'polished';
import _taggedTemplateLiteralLoose from '@babel/runtime/helpers/esm/taggedTemplateLiteralLoose';
import _extends from '@babel/runtime/helpers/esm/extends';
import React from 'react';
import styled, { css as css$1, Box, createGlobalStyle } from '@xstyled/styled-components';
export { Box } from '@xstyled/styled-components';
import { merge, omit } from '@xstyled/util';
import { oneOfType, number, string, object, bool, node, oneOf, func, any } from 'prop-desc';
import _objectWithoutPropertiesLoose from '@babel/runtime/helpers/esm/objectWithoutPropertiesLoose';
import { Button as Button$1 } from 'reakit/Button';
import flattenChildren from 'react-flatten-children';
import { Checkbox as Checkbox$1 } from 'reakit/Checkbox';
export { useCheckboxState } from 'reakit/Checkbox';
import { Separator as Separator$1 } from 'reakit';
import { Menu as Menu$1, MenuItem as MenuItem$1, MenuDisclosure as MenuDisclosure$1, MenuSeparator as MenuSeparator$1 } from 'reakit/Menu';
export { useMenuState } from 'reakit/Menu';
import { RadioGroup as RadioGroup$1, Radio as Radio$1 } from 'reakit/Radio';
export { useRadioState } from 'reakit/Radio';
import mergeRefs from 'react-merge-refs';

var colorLevel = function colorLevel(color, level) {
  return function (p) {
    var colorInterval = p.theme.colorInterval || 0.08;
    var baseColor = level > 0 ? th.color('darker')(p) : th.color('lighter')(p);
    var absLevel = Math.abs(level);
    return mix(absLevel * colorInterval, baseColor, color);
  };
};

var defaultColor = function defaultColor(name, defaultValue) {
  return function (p) {
    var value = th.color(name)(p);
    if (value === name) return defaultValue;
    return value;
  };
};

var colorYik = function colorYik(color) {
  return function (p) {
    var darkValue = defaultColor('yik.dark', '#111')(p);
    var lightValue = defaultColor('yik.light', '#fff')(p);
    var colorValue = th.color(color)(p);
    var darkContrast = getContrast(colorValue, darkValue);
    var lightContrast = getContrast(colorValue, lightValue);
    return darkContrast < lightContrast + 4 ? lightValue : darkValue;
  };
};

var systemProps = ['background', 'backgroundColor', 'backgroundImage', 'backgroundSize', 'backgroundPosition', 'backgroundRepeat', 'opacity', 'overflow', 'transition', 'border', 'borderTop', 'borderTopColor', 'borderRight', 'borderRightColor', 'borderBottom', 'borderBottomColor', 'borderLeft', 'borderLeftColor', 'borderColor', 'borderWidth', 'borderStyle', 'borderRadius', 'boxShadow', 'display', 'alignItems', 'alignContent', 'justifyContent', 'justifyItems', 'flexWrap', 'flexBasis', 'flexDirection', 'flex', 'justifySelf', 'alignSelf', 'order', 'gridGap', 'gridColumnGap', 'gridRowGap', 'gridColumn', 'gridRow', 'gridAutoFlow', 'gridAutoColumns', 'gridAutoRows', 'gridTemplateColumns', 'gridTemplateRows', 'gridTemplateAreas', 'gridArea', 'display', 'width', 'height', 'maxWidth', 'maxHeight', 'minWidth', 'minHeight', 'size', 'verticalAlign', 'position', 'zIndex', 'top', 'right', 'bottom', 'left', 'margin', 'm', 'marginTop', 'mt', 'marginRight', 'mr', 'marginBottom', 'mb', 'marginLeft', 'ml', 'mx', 'my', 'padding', 'p', 'paddingTop', 'pt', 'paddingRight', 'pr', 'paddingBottom', 'pb', 'paddingLeft', 'pl', 'px', 'py', 'fontFamily', 'fontSize', 'lineHeight', 'fontWeight', 'textAlign', 'letterSpacing', 'color', 'textTransform', 'row', 'col'];
var systemPropTypes = {
  row: [bool, object],
  col: [bool, number, string, object]
};

function getSystemPropTypes(system) {
  if (!system) return {};
  return system.meta.props.reduce(function (obj, prop) {
    obj[prop] = oneOfType(systemPropTypes[prop] || [number, string, object]).desc('[xstyled] See <a href="https://www.smooth-code.com/open-source/xstyled/docs/system-props/">xstyled documentation</a>');
    return obj;
  }, {});
}

function mergeClone() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  return args.reduce(function (result, obj) {
    return merge(result, obj);
  }, {});
}

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n    ", "\n  "]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var omittedProps =
/*#__PURE__*/
['as', 'forwardedAs', 'variant', 'scale'].concat(systemProps);

function useProps(props) {
  var as = props.as || props.forwardedAs || undefined;
  return {
    as: as,
    safeProps: omit(props, omittedProps)
  };
}

var cacheSupported = typeof Map !== 'undefined' && typeof WeakMap !== 'undefined';
var caches = cacheSupported ?
/*#__PURE__*/
new WeakMap() : null;

function getThemeCache(theme) {
  if (caches.has(theme)) return caches.get(theme);
  var cache = {};
  caches.set(theme, cache);
  return cache;
}

function createInnerComponent(_ref) {
  var name = _ref.name,
      render = _ref.render,
      _ref$theme = _ref.theme,
      theme = _ref$theme === void 0 ? {} : _ref$theme;
  var InnerComponent = React.forwardRef(function InnerComponent(props, ref) {
    var _useProps = useProps(props),
        as = _useProps.as,
        safeProps = _useProps.safeProps;

    return render(_extends({
      ref: ref,
      as: as
    }, safeProps), _extends({
      theme: theme
    }, props));
  });
  InnerComponent.displayName = name;
  return InnerComponent;
}

function computeTheme(baseTheme, customTheme) {
  var theme = mergeClone(baseTheme, customTheme);
  if (!theme.colors || !theme.colors.modes) return baseTheme;
  return _extends({}, theme, {
    colors: _extends({}, theme.colors, {}, theme.colors.modes[theme.colorMode || theme.__colorMode])
  });
}

function createComponent(_ref2) {
  var name = _ref2.name,
      render = _ref2.render,
      _ref2$theme = _ref2.theme,
      theme = _ref2$theme === void 0 ? {} : _ref2$theme,
      propTypes = _ref2.propTypes;
  theme = Array.isArray(theme) ? mergeClone.apply(void 0, theme) : theme;
  var InnerComponent = createInnerComponent({
    name: name,
    render: render,
    theme: theme
  });
  var Component = styled(InnerComponent)(_templateObject(), function (p) {
    var cache = getThemeCache(p.theme);
    cache[name] = cache[name] || computeTheme(theme, p.theme);

    var props = _extends({}, p, {
      theme: cache[name]
    });

    var componentStyle = props.theme.components ? props.theme.components[name] : null;
    return componentStyle ? componentStyle(props) : null;
  });
  Component.displayName = "styled(" + name + ")";
  Component.propTypes = propTypes;
  return Component;
}

function useRandomId(prefix) {
  return React.useMemo(function () {
    return "" + (prefix ? prefix + "-" : '') + Math.random().toString(36).substring(7);
  }, [prefix]);
}

function css() {
  var result = css$1.apply(void 0, arguments);
  if (typeof result === 'function') return result;
  return function () {
    return result;
  };
}

var SCALES = ['xs', 'sm', 'base', 'lg', 'xl'];

function scale(base, baseGetter, ratio) {
  return {
    xs: function xs(p) {
      return modularScale(-2, baseGetter(p), ratio);
    },
    sm: function sm(p) {
      return modularScale(-1, baseGetter(p), ratio);
    },
    base: base,
    lg: function lg(p) {
      return modularScale(1, baseGetter(p), ratio);
    },
    xl: function xl(p) {
      return modularScale(2, baseGetter(p), ratio);
    }
  };
}

function _templateObject2() {
  var data = _taggedTemplateLiteralLoose(["\n    ", ";\n    transition-property: color, border-style, border-color, visibility,\n      background, background-color, text-decoration, box-shadow, transform,\n      opacity;\n  "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$1() {
  var data = _taggedTemplateLiteralLoose(["\n    transition: ", ";\n\n    @media screen and (prefers-reduced-motion: reduce) {\n      transition: none;\n    }\n  "]);

  _templateObject$1 = function _templateObject() {
    return data;
  };

  return data;
}

var transitionEnabled = true;

var transition = function transition(value) {
  return function (p) {
    if (p.theme.transitionEnabled === false) return null;
    return css(_templateObject$1(), th.transition(value)(p))(p);
  };
};

var safeTransition = function safeTransition(value) {
  return function (p) {
    var transitionValue = transition(value)(p);
    if (!transitionValue) return null;
    return css(_templateObject2(), transitionValue)(p);
  };
};

var VARIANTS = ['primary', 'secondary', 'success', 'info', 'warning', 'danger', 'light', 'dark'];
/* eslint-disable no-use-before-define */

var radii =
/*#__PURE__*/
scale(
/*#__PURE__*/
th.px('4rpx'),
/*#__PURE__*/
th.radius('base'));
var borderWidths =
/*#__PURE__*/
scale(
/*#__PURE__*/
th.px('1rpx'),
/*#__PURE__*/
th.borderWidth('base'));
var colors = {
  black: '#000',
  white: '#fff',
  gray100: '#f8f9fa',
  gray200: '#e9ecef',
  gray300: '#dee2e6',
  gray400: '#ced4da',
  gray500: '#adb5bd',
  gray600: '#6c757d',
  gray700: '#495057',
  gray800: '#343a40',
  gray900: '#212529',
  blue: '#007bff',
  indigo: '#6610f2',
  purple: '#6f42c1',
  pink: '#e83e8c',
  red: '#dc3545',
  brick: '#bd4932',
  orange: '#fd7e14',
  yellow: '#ffc107',
  green: '#28a745',
  teal: '#20c997',
  cyan: '#17a2b8',
  primary:
  /*#__PURE__*/
  th.color('brick'),
  secondary:
  /*#__PURE__*/
  th.color('gray600'),
  success:
  /*#__PURE__*/
  th.color('green'),
  info:
  /*#__PURE__*/
  th.color('cyan'),
  warning:
  /*#__PURE__*/
  th.color('yellow'),
  danger:
  /*#__PURE__*/
  th.color('red'),
  light:
  /*#__PURE__*/
  th.color('gray100'),
  dark:
  /*#__PURE__*/
  th.color('gray800'),
  lighter:
  /*#__PURE__*/
  th.color('white'),
  light100:
  /*#__PURE__*/
  th.color('gray100'),
  light200:
  /*#__PURE__*/
  th.color('gray200'),
  light300:
  /*#__PURE__*/
  th.color('gray300'),
  light400:
  /*#__PURE__*/
  th.color('gray400'),
  light500:
  /*#__PURE__*/
  th.color('gray500'),
  light600:
  /*#__PURE__*/
  th.color('gray600'),
  light700:
  /*#__PURE__*/
  th.color('gray700'),
  light800:
  /*#__PURE__*/
  th.color('gray800'),
  light900:
  /*#__PURE__*/
  th.color('gray900'),
  darker:
  /*#__PURE__*/
  th.color('black'),
  highlightBackground: function highlightBackground(p) {
    return transparentize(0.96, th.color('darker')(p));
  },
  highlightBorder: function highlightBorder(p) {
    return transparentize(0.875, th.color('darker')(p));
  },
  form: {
    valid:
    /*#__PURE__*/
    th.color('success'),
    invalid:
    /*#__PURE__*/
    th.color('danger')
  },
  modes: {
    dark: {
      lighter:
      /*#__PURE__*/
      th.color('black'),
      darker:
      /*#__PURE__*/
      th.color('white'),
      light100:
      /*#__PURE__*/
      th.color('gray900'),
      light200:
      /*#__PURE__*/
      th.color('gray800'),
      light300:
      /*#__PURE__*/
      th.color('gray700'),
      light400:
      /*#__PURE__*/
      th.color('gray600'),
      light500:
      /*#__PURE__*/
      th.color('gray500'),
      light600:
      /*#__PURE__*/
      th.color('gray400'),
      light700:
      /*#__PURE__*/
      th.color('gray300'),
      light800:
      /*#__PURE__*/
      th.color('gray200'),
      light900:
      /*#__PURE__*/
      th.color('gray100')
    }
  }
};

function _templateObject2$1() {
  var data = _taggedTemplateLiteralLoose(["\n      outline: 0;\n      border-color: ", ";\n      box-shadow: 0 0 0 ", " ", ";\n    "]);

  _templateObject2$1 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$2() {
  var data = _taggedTemplateLiteralLoose(["\n      outline: 0;\n      border-color: ", ";\n      box-shadow: 0 0 ", " ", ";\n    "]);

  _templateObject$2 = function _templateObject() {
    return data;
  };

  return data;
}

var mixins = {
  baseFocus: function baseFocus(color) {
    return function (p) {
      var colorValue = th.color(color)(p);
      return css(_templateObject$2(), lighten(0.25, colorValue), th.px('2rpx')(p), transparentize(0.1, colorValue))(p);
    };
  },
  controlFocus: function controlFocus(color) {
    return function (p) {
      var colorValue = th.color(color)(p);
      return css(_templateObject2$1(), lighten(0.25, colorValue), th.px('4rpx')(p), transparentize(0.75, colorValue))(p);
    };
  }
};
/* eslint-disable no-use-before-define */

var fontSizes =
/*#__PURE__*/
scale('1rem',
/*#__PURE__*/
th.fontSize('base'));
var fonts = {
  base: '-apple-system,system-ui,BlinkMacSystemFont,"Segoe UI",Roboto,"Helvetica Neue",Arial,sans-serif'
}; // From https://developer.mozilla.org/en-US/docs/Web/CSS/font-weight#Common_weight_name_mapping

var fontWeights = {
  thin: 100,
  extraLight: 200,
  light: 300,
  normal: 400,
  medium: 500,
  semiBold: 600,
  bold: 700,
  extraBold: 800,
  black: 900
};
var lineHeights =
/*#__PURE__*/
SCALES.reduce(function (obj, scale) {
  obj[scale] = 1.5;
  return obj;
}, {
  button: {}
});
var transitions = {
  base: '.2s ease-in-out'
};
var zIndices = {
  control: 1
};
var theme =
/*#__PURE__*/
Object.freeze({
  radii: radii,
  borderWidths: borderWidths,
  colors: colors,
  mixins: mixins,
  fontSizes: fontSizes,
  fonts: fonts,
  fontWeights: fontWeights,
  lineHeights: lineHeights,
  transitions: transitions,
  zIndices: zIndices
});

function _templateObject$3() {
  var data = _taggedTemplateLiteralLoose(["\n            font-family: ", ";\n            position: relative;\n            padding: 12rpx 20rpx;\n            margin-bottom: 16rpx;\n            border: 1rpx;\n            border-color: transparent;\n            border-radius: ", ";\n            color: ", ";\n            background-color: ", ";\n            border-color: ", ";\n\n            hr {\n              border-top-color: ", ";\n            }\n\n            && {\n              ", "\n            }\n          "]);

  _templateObject$3 = function _templateObject() {
    return data;
  };

  return data;
}

var Alert =
/*#__PURE__*/
createComponent({
  name: 'Alert',
  render: function render(_ref) {
    var _ref$as = _ref.as,
        As = _ref$as === void 0 ? 'p' : _ref$as,
        props = _objectWithoutPropertiesLoose(_ref, ["as"]);

    return React.createElement(As, _extends({
      role: "alert"
    }, props));
  },
  theme: [theme, {
    colorLevels: {
      Alert: {
        color: 6,
        backgroundColor: -10,
        borderColor: -9
      }
    },
    components: {
      Alert: function Alert(p) {
        var baseColor = p.variant === null ? null : th.color(p.variant || 'primary')(p);
        var textColorLevel = th('colorLevels.Alert.color')(p);
        var backgroundColorLevel = th('colorLevels.Alert.backgroundColor')(p);
        var borderColorLevel = th('colorLevels.Alert.borderColor')(p);
        var color = colorLevel(baseColor, textColorLevel)(p);
        var backgroundColor = colorLevel(baseColor, backgroundColorLevel)(p);
        var borderColor = colorLevel(baseColor, borderColorLevel)(p);
        var hrColor = darken(0.05, color);
        return css(_templateObject$3(), th.font('base')(p), th.radius('base')(p), color, backgroundColor, borderColor, hrColor, system$1(p));
      }
    }
  }],
  propTypes:
  /*#__PURE__*/
  _extends({
    children: node,
    variant:
    /*#__PURE__*/
    oneOfType([oneOf(VARIANTS), string]).defaultTo('primary').desc('Control the color variant of the component.')
  },
  /*#__PURE__*/
  getSystemPropTypes(system$1))
});
var space = {
  textFormControl: {
    x: {
      xs: '4rpx',
      sm: '8rpx',
      base: '10rpx',
      lg: '14rpx',
      xl: '18rpx'
    },
    y: {
      xs: '3rpx',
      sm: '4rpx',
      base: '6rpx',
      lg: '8rpx',
      xl: '10rpx'
    }
  }
};

var colors$1 =
/*#__PURE__*/
_extends({}, colors, {
  formControl: {
    background:
    /*#__PURE__*/
    th.color('lighter'),
    border:
    /*#__PURE__*/
    th.color('light400'),
    text:
    /*#__PURE__*/
    th.color('light900'),
    placeholder:
    /*#__PURE__*/
    th.color('light600'),
    disabled: {
      background:
      /*#__PURE__*/
      th.color('light100'),
      text:
      /*#__PURE__*/
      th.color('light900')
    }
  }
});

var borderWidths$1 = {
  formControl:
  /*#__PURE__*/
  SCALES.reduce(function (obj, scale) {
    obj[scale] = '1rpx';
    return obj;
  }, {})
};

var lineHeights$1 =
/*#__PURE__*/
_extends({}, lineHeights, {
  formControl:
  /*#__PURE__*/
  SCALES.reduce(function (obj, scale) {
    obj[scale] = th.lineHeight(scale);
    return obj;
  }, {})
});

var formTheme =
/*#__PURE__*/
Object.freeze({
  space: space,
  colors: colors$1,
  borderWidths: borderWidths$1,
  lineHeights: lineHeights$1
});

function _templateObject2$2() {
  var data = _taggedTemplateLiteralLoose(["\n                color: ", ";\n                background-color: ", ";\n\n                &:focus {\n                  ", ";\n                }\n\n                &:not(:disabled):hover,\n                &:not(:disabled):active {\n                  color: ", ";\n                  background-color: ", ";\n                }\n              "]);

  _templateObject2$2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$4() {
  var data = _taggedTemplateLiteralLoose(["\n            display: inline-block;\n            z-index: ", ";\n            font-family: ", ";\n            font-size: ", ";\n            padding: ", " ", ";\n            border-radius: ", ";\n            line-height: ", ";\n            border-width: ", ";\n            cursor: ", ";\n            ", ";\n\n            /* When used as link */\n            text-decoration: none;\n\n            &[type='button'] {\n              appearance: none;\n            }\n\n            &:disabled {\n              opacity: 0.8;\n            }\n\n            ", "\n\n            && {\n              ", "\n            }\n          "]);

  _templateObject$4 = function _templateObject() {
    return data;
  };

  return data;
}

var Button =
/*#__PURE__*/
createComponent({
  name: 'Button',
  render: function render(props) {
    return React.createElement(Button$1, props);
  },
  theme: [theme, formTheme, {
    borderWidths: {
      button:
      /*#__PURE__*/
      SCALES.reduce(function (obj, scale) {
        obj[scale] = 0;
        return obj;
      }, {})
    },
    components: {
      Button: function Button(p) {
        var scale = p.scale || 'base';
        var baseColor = p.variant === null ? null : th.color(p.variant || 'primary')(p);
        var px = th.space("textFormControl.x." + scale)(p);
        var py = th.space("textFormControl.y." + scale)(p);
        return css(_templateObject$4(), th.zIndex('control')(p), th.font('base')(p), th.fontSize(scale)(p), py, px, th.radius(scale)(p), th.lineHeight("formControl." + scale)(p), th.borderWidth("button." + scale)(p), p.disabled ? 'initial' : 'pointer', safeTransition('base')(p), baseColor && css(_templateObject2$2(), colorYik(baseColor)(p), baseColor, p.theme.mixins.controlFocus(baseColor)(p), colorYik(baseColor)(p), darken(0.05, baseColor))(p), system$1(p));
      }
    }
  }],
  propTypes:
  /*#__PURE__*/
  _extends({
    children: node,
    disabled:
    /*#__PURE__*/
    bool.desc('Same as the HTML attribute.'),
    focusable:
    /*#__PURE__*/
    bool.desc('When an element is `disabled`, it may still be `focusable`. It works similarly to `readOnly` on form elements. In this case, only `aria-disabled` will be set.'),
    scale:
    /*#__PURE__*/
    oneOf(SCALES).desc('Control the size of the component.'),
    variant:
    /*#__PURE__*/
    oneOfType([oneOf(VARIANTS), string]).defaultTo('primary').desc('Control the color variant of the component.')
  },
  /*#__PURE__*/
  getSystemPropTypes(system$1))
});
Box.propTypes =
/*#__PURE__*/
getSystemPropTypes(system$1);

function Boxer(_ref) {
  var children = _ref.children,
      props = _objectWithoutPropertiesLoose(_ref, ["children"]);

  return flattenChildren(children).map(function (child) {
    return React.createElement(Box, _extends({
      key: child.key
    }, props), child);
  });
}

Boxer.propTypes =
/*#__PURE__*/
getSystemPropTypes(system$1);

function _templateObject7() {
  var data = _taggedTemplateLiteralLoose(["\n            flex-shrink: 0; /* For IE: https://github.com/twbs/bootstrap/issues/29396 */\n            width: 100%; /* Required because we use flexbox and this inherently applies align-self: stretch */\n\n            &:first-child {\n              border-radius: calc(", " - 1px) calc(", " - 1px)\n                0 0;\n            }\n\n            &:last-child {\n              border-radius: 0 0 calc(", " - 1px)\n                calc(", " - 1px);\n            }\n\n            && {\n              ", "\n            }\n          "]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = _taggedTemplateLiteralLoose(["\n            padding: 0.75rem 1.25rem;\n            background-color: ", ";\n            border-top: 0.0625rem solid;\n            border-top-color: ", ";\n\n            &:last-child {\n              border-radius: 0 0 calc(", " - 1px)\n                calc(", " - 1px);\n            }\n\n            && {\n              ", "\n            }\n          "]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteralLoose(["\n            padding: 0.75rem 1.25rem;\n            margin-bottom: 0; /* Removes the default margin-bottom of <hN> */\n            background-color: ", ";\n            border-bottom: 0.0625rem solid;\n            border-bottom-color: ", ";\n\n            &:first-child {\n              border-radius: calc(", " - 1px) calc(", " - 1px)\n                0 0;\n            }\n\n            && {\n              ", "\n            }\n          "]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteralLoose(["\n            &:last-child {\n              margin-bottom: 0;\n            }\n\n            && {\n              ", "\n            }\n          "]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteralLoose(["\n            margin-bottom: 12rpx;\n\n            && {\n              ", "\n            }\n          "]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$3() {
  var data = _taggedTemplateLiteralLoose(["\n            flex: 1 1 auto;\n            padding: 20rpx;\n\n            && {\n              ", "\n            }\n          "]);

  _templateObject2$3 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$5() {
  var data = _taggedTemplateLiteralLoose(["\n            position: relative;\n            display: flex;\n            flex-direction: column;\n            min-width: 0;\n            word-wrap: break-word;\n            background-color: ", ";\n            background-clip: border-box;\n            border: 0.0625rem solid;\n            border-color: ", ";\n            border-radius: ", ";\n            font-family: ", ";\n\n            && {\n              ", "\n            }\n          "]);

  _templateObject$5 = function _templateObject() {
    return data;
  };

  return data;
}

var Card =
/*#__PURE__*/
createComponent({
  name: 'Card',
  render: function render(_ref) {
    var _ref$as = _ref.as,
        As = _ref$as === void 0 ? 'div' : _ref$as,
        props = _objectWithoutPropertiesLoose(_ref, ["as"]);

    return React.createElement(As, props);
  },
  theme: [theme, {
    components: {
      Card: function Card(p) {
        return css(_templateObject$5(), th.color('lighter')(p), th.color('highlightBorder')(p), th.radius('base')(p), th.font('base')(p), system$1(p));
      }
    }
  }],
  propTypes:
  /*#__PURE__*/
  _extends({
    children: node
  },
  /*#__PURE__*/
  getSystemPropTypes(system$1))
});
var CardBody =
/*#__PURE__*/
createComponent({
  name: 'CardBody',
  render: function render(_ref2) {
    var _ref2$as = _ref2.as,
        As = _ref2$as === void 0 ? 'div' : _ref2$as,
        props = _objectWithoutPropertiesLoose(_ref2, ["as"]);

    return React.createElement(As, props);
  },
  theme: [theme, {
    components: {
      CardBody: function CardBody(p) {
        return css(_templateObject2$3(), system$1(p));
      }
    }
  }],
  propTypes:
  /*#__PURE__*/
  _extends({
    children: node
  },
  /*#__PURE__*/
  getSystemPropTypes(system$1))
});
var CardTitle =
/*#__PURE__*/
createComponent({
  name: 'CardTitle',
  render: function render(_ref3) {
    var _ref3$as = _ref3.as,
        As = _ref3$as === void 0 ? 'div' : _ref3$as,
        props = _objectWithoutPropertiesLoose(_ref3, ["as"]);

    return React.createElement(As, props);
  },
  theme: [theme, {
    components: {
      CardTitle: function CardTitle(p) {
        return css(_templateObject3(), system$1(p));
      }
    }
  }],
  propTypes:
  /*#__PURE__*/
  _extends({
    children: node
  },
  /*#__PURE__*/
  getSystemPropTypes(system$1))
});
var CardText =
/*#__PURE__*/
createComponent({
  name: 'CardText',
  render: function render(_ref4) {
    var _ref4$as = _ref4.as,
        As = _ref4$as === void 0 ? 'p' : _ref4$as,
        props = _objectWithoutPropertiesLoose(_ref4, ["as"]);

    return React.createElement(As, props);
  },
  theme: [theme, {
    components: {
      CardText: function CardText(p) {
        return css(_templateObject4(), system$1(p));
      }
    }
  }],
  propTypes:
  /*#__PURE__*/
  _extends({
    children: node
  },
  /*#__PURE__*/
  getSystemPropTypes(system$1))
});
var CardHeader =
/*#__PURE__*/
createComponent({
  name: 'CardHeader',
  render: function render(_ref5) {
    var _ref5$as = _ref5.as,
        As = _ref5$as === void 0 ? 'div' : _ref5$as,
        props = _objectWithoutPropertiesLoose(_ref5, ["as"]);

    return React.createElement(As, props);
  },
  theme: [theme, {
    components: {
      CardHeader: function CardHeader(p) {
        var baseRadius = th.radius('base')(p);
        return css(_templateObject5(), th.color('highlightBackground')(p), th.color('highlightBorder')(p), baseRadius, baseRadius, system$1(p));
      }
    }
  }],
  propTypes:
  /*#__PURE__*/
  _extends({
    children: node
  },
  /*#__PURE__*/
  getSystemPropTypes(system$1))
});
var CardFooter =
/*#__PURE__*/
createComponent({
  name: 'CardFooter',
  render: function render(_ref6) {
    var _ref6$as = _ref6.as,
        As = _ref6$as === void 0 ? 'div' : _ref6$as,
        props = _objectWithoutPropertiesLoose(_ref6, ["as"]);

    return React.createElement(As, props);
  },
  theme: [theme, {
    components: {
      CardFooter: function CardFooter(p) {
        var baseRadius = th.radius('base')(p);
        return css(_templateObject6(), th.color('highlightBackground')(p), th.color('highlightBorder')(p), baseRadius, baseRadius, system$1(p));
      }
    }
  }],
  propTypes:
  /*#__PURE__*/
  _extends({
    children: node
  },
  /*#__PURE__*/
  getSystemPropTypes(system$1))
});
var CardImg =
/*#__PURE__*/
createComponent({
  name: 'CardImg',
  render: function render(_ref7) {
    var _ref7$as = _ref7.as,
        As = _ref7$as === void 0 ? 'img' : _ref7$as,
        props = _objectWithoutPropertiesLoose(_ref7, ["as"]);

    return React.createElement(As, props);
  },
  theme: [theme, {
    components: {
      CardImg: function CardImg(p) {
        var baseRadius = th.radius('base')(p);
        return css(_templateObject7(), baseRadius, baseRadius, baseRadius, baseRadius, system$1(p));
      }
    }
  }],
  propTypes:
  /*#__PURE__*/
  _extends({
    children: node
  },
  /*#__PURE__*/
  getSystemPropTypes(system$1))
});

function _templateObject6$1() {
  var data = _taggedTemplateLiteralLoose(["\n            font-family: ", ";\n            font-size: ", ";\n            padding-left: ", ";\n\n            [aria-disabled='true'] ~ & {\n              opacity: 0.6;\n            }\n          "]);

  _templateObject6$1 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5$1() {
  var data = _taggedTemplateLiteralLoose(["\n          display: flex;\n          align-items: center;\n\n          && {\n            ", "\n          }\n        "]);

  _templateObject5$1 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4$1() {
  var data = _taggedTemplateLiteralLoose(["\n                padding-top: calc(", " + 1px);\n                padding-bottom: calc(", " + 1px);\n                margin-bottom: 0;\n              "]);

  _templateObject4$1 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3$1() {
  var data = _taggedTemplateLiteralLoose(["\n            font-family: ", ";\n            font-size: ", ";\n            display: inline-block;\n            margin-bottom: ", ";\n            font-weight: ", ";\n\n            ", "\n\n            [aria-disabled='true'] ~ & {\n              opacity: 0.6;\n            }\n\n            && {\n              ", "\n            }\n          "]);

  _templateObject3$1 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$4() {
  var data = _taggedTemplateLiteralLoose(["\n          margin-bottom: ", ";\n\n          && {\n            ", "\n          }\n        "]);

  _templateObject2$4 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$6() {
  var data = _taggedTemplateLiteralLoose(["\n          && {\n            ", "\n          }\n        "]);

  _templateObject$6 = function _templateObject() {
    return data;
  };

  return data;
}

function createFieldsGroupContext(type) {
  var FieldsGroupContext = React.createContext();

  function useFieldsGroupState() {
    return React.useContext(FieldsGroupContext);
  }

  function useCreateFieldsGroupState(baseId) {
    var randomId = useRandomId(type);
    var id = baseId || randomId;

    var _React$useState = React.useState({}),
        labels = _React$useState[0],
        setLabels = _React$useState[1];

    var registerLabel = React.useCallback(function (name, id) {
      setLabels(function (labels) {
        var _extends2;

        return _extends({}, labels, (_extends2 = {}, _extends2[name] = id, _extends2));
      });
    }, []);
    var unregisterLabel = React.useCallback(function (name) {
      setLabels(function (labels) {
        var newLabels = _extends({}, labels);

        delete newLabels[name];
        return newLabels;
      });
    }, []);
    return React.useMemo(function () {
      return {
        id: id,
        labels: labels,
        registerLabel: registerLabel,
        unregisterLabel: unregisterLabel
      };
    }, [id, labels, registerLabel, unregisterLabel]);
  }

  function Provider(_ref) {
    var id = _ref.id,
        children = _ref.children;
    var fieldsGroupState = useCreateFieldsGroupState(id);
    return React.createElement(FieldsGroupContext.Provider, {
      value: fieldsGroupState
    }, children);
  }

  function useRegisterLabel(name, id) {
    var fieldsGroupState = useFieldsGroupState();
    var hasFormState = Boolean(fieldsGroupState);

    var _ref2 = fieldsGroupState || {},
        registerLabel = _ref2.registerLabel,
        unregisterLabel = _ref2.unregisterLabel;

    React.useEffect(function () {
      if (name && id && hasFormState) {
        registerLabel(name, id);
        return function () {
          unregisterLabel(name);
        };
      }

      return undefined;
    }, [name, id, hasFormState, registerLabel, unregisterLabel]);
  }

  function getControlId(fieldsGroupId, name) {
    return fieldsGroupId + "-" + name;
  }

  function getLabelId(controlId) {
    return controlId && controlId + "-label";
  }

  function useControlId(name, baseId) {
    var fieldsGroupState = useFieldsGroupState();
    var id = React.useMemo(function () {
      if (baseId) return baseId;
      if (fieldsGroupState && name) return getControlId(fieldsGroupState.id, name);
      return null;
    }, [fieldsGroupState, name, baseId]);
    return id;
  }

  function useControlProps(props) {
    var fieldsGroupState = useFieldsGroupState();
    var id = useControlId(props.name, props.id);
    var labelId = props.name && fieldsGroupState && fieldsGroupState.labels[props.name] || null;
    return _extends({}, props, {
      id: id,
      'aria-labelledby': props['aria-labelledby'] || labelId
    });
  }

  function useLabelProps(_ref3) {
    var name = _ref3.name,
        props = _objectWithoutPropertiesLoose(_ref3, ["name"]);

    var controlId = useControlId(name);
    var labelId = getLabelId(controlId);
    useRegisterLabel(name, labelId);
    return _extends({
      id: labelId,
      htmlFor: controlId
    }, props);
  }

  return {
    Provider: Provider,
    useControlProps: useControlProps,
    useLabelProps: useLabelProps
  };
}

var _createFieldsGroupCon =
/*#__PURE__*/
createFieldsGroupContext('form'),
    FormProvider = _createFieldsGroupCon.Provider,
    useFormControlProps = _createFieldsGroupCon.useControlProps,
    useFormLabelProps = _createFieldsGroupCon.useLabelProps;

var _createFieldsGroupCon2 =
/*#__PURE__*/
createFieldsGroupContext('group'),
    FromGroupProvider = _createFieldsGroupCon2.Provider,
    useFormGroupControlProps = _createFieldsGroupCon2.useControlProps,
    useFormGroupLabelProps = _createFieldsGroupCon2.useLabelProps;

var Form =
/*#__PURE__*/
createComponent({
  name: 'Form',
  render: function render(_ref4) {
    var _ref4$as = _ref4.as,
        As = _ref4$as === void 0 ? 'form' : _ref4$as,
        props = _objectWithoutPropertiesLoose(_ref4, ["as"]);

    var role = As === 'form' ? null : 'form';
    return React.createElement(FormProvider, {
      id: props.id
    }, React.createElement(As, _extends({
      role: role
    }, props)));
  },
  theme: {
    components: {
      Form: function Form(p) {
        return css(_templateObject$6(), system$1(p));
      }
    }
  },
  propTypes:
  /*#__PURE__*/
  _extends({
    children: node
  },
  /*#__PURE__*/
  getSystemPropTypes(system$1))
});
var FormField =
/*#__PURE__*/
createComponent({
  name: 'FormField',
  render: function render(_ref5) {
    var _ref5$as = _ref5.as,
        As = _ref5$as === void 0 ? 'div' : _ref5$as,
        props = _objectWithoutPropertiesLoose(_ref5, ["as"]);

    return React.createElement(As, props);
  },
  theme: {
    space: {
      formField: {
        bottom:
        /*#__PURE__*/
        scale('1rem',
        /*#__PURE__*/
        th.space('formField.bottom.base'))
      }
    },
    components: {
      FormField: function FormField(p) {
        var _p$scale = p.scale,
            scale = _p$scale === void 0 ? 'base' : _p$scale;
        var mb = th.space("formField.bottom." + scale)(p);
        return css(_templateObject2$4(), mb, system$1(p));
      }
    }
  },
  propTypes:
  /*#__PURE__*/
  _extends({
    children: node,
    scale:
    /*#__PURE__*/
    oneOf(SCALES).desc('Control the size of the component.').defaultTo('base')
  },
  /*#__PURE__*/
  getSystemPropTypes(system$1))
});
var FormFieldLabel =
/*#__PURE__*/
createComponent({
  name: 'FormFieldLabel',
  render: function render(_ref6) {
    var _ref6$as = _ref6.as,
        As = _ref6$as === void 0 ? 'label' : _ref6$as,
        scale = _ref6.scale,
        props = _objectWithoutPropertiesLoose(_ref6, ["as", "scale"]);

    var labelProps = useFormLabelProps(props);
    return React.createElement(As, labelProps);
  },
  theme: [theme, formTheme, {
    space: {
      formFieldLabel: {
        bottom:
        /*#__PURE__*/
        scale('0.5rem',
        /*#__PURE__*/
        th.space('formFieldLabel.bottom.base'))
      }
    }
  }, {
    components: {
      FormFieldLabel: function FormFieldLabel(p) {
        var _p$scale2 = p.scale,
            scale = _p$scale2 === void 0 ? 'base' : _p$scale2;
        var py = th.space("textFormControl.y." + scale)(p);
        var mb = th.space("formFieldLabel.bottom." + scale)(p);
        return css(_templateObject3$1(), th.font('base')(p), th.fontSize(scale)(p), mb, th.fontWeight('medium')(p), p.col && css(_templateObject4$1(), py, py)(p), system$1(p));
      }
    }
  }],
  propTypes:
  /*#__PURE__*/
  _extends({
    children: node,
    scale:
    /*#__PURE__*/
    oneOf(SCALES).desc('Control the size of the component.').defaultTo('base')
  },
  /*#__PURE__*/
  getSystemPropTypes(system$1))
});
var FormCheck =
/*#__PURE__*/
createComponent({
  name: 'FormCheck',
  render: function render(_ref7) {
    var _ref7$as = _ref7.as,
        As = _ref7$as === void 0 ? 'div' : _ref7$as,
        props = _objectWithoutPropertiesLoose(_ref7, ["as"]);

    return React.createElement(FromGroupProvider, {
      value: props.id
    }, React.createElement(As, _extends({
      "data-form-check": true
    }, props)));
  },
  theme: {
    components: {
      FormCheck: function FormCheck(p) {
        return css(_templateObject5$1(), system$1(p));
      }
    }
  },
  propTypes: {
    children: node
  }
});
var FormCheckLabel =
/*#__PURE__*/
createComponent({
  name: 'FormCheckLabel',
  render: function render(_ref8) {
    var _ref8$as = _ref8.as,
        As = _ref8$as === void 0 ? 'label' : _ref8$as,
        props = _objectWithoutPropertiesLoose(_ref8, ["as"]);

    var labelProps = useFormGroupLabelProps(props);
    return React.createElement(As, labelProps);
  },
  theme: [theme, formTheme, {
    space: {
      formCheckLabel: {
        left:
        /*#__PURE__*/
        scale('0.375rem',
        /*#__PURE__*/
        th.space('formCheckLabel.left.base'))
      }
    }
  }, {
    components: {
      FormCheckLabel: function FormCheckLabel(p) {
        var _p$scale3 = p.scale,
            scale = _p$scale3 === void 0 ? 'base' : _p$scale3;
        var pl = th.space("formCheckLabel.left." + scale)(p);
        return css(_templateObject6$1(), th.font('base')(p), th.fontSize(scale)(p), pl);
      }
    }
  }],
  propTypes:
  /*#__PURE__*/
  _extends({
    children: node,
    scale:
    /*#__PURE__*/
    oneOf(SCALES).desc('Control the size of the component.').defaultTo('base')
  },
  /*#__PURE__*/
  getSystemPropTypes(system$1))
});

function _templateObject3$2() {
  var data = _taggedTemplateLiteralLoose(["\n            display: inline-flex;\n            align-items: center;\n            justify-content: center;\n            position: relative;\n            width: ", ";\n            height: ", ";\n            z-index: ", ";\n            background-color: ", ";\n            border-radius: ", ";\n            border-style: solid;\n            border-width: ", ";\n            border-color: ", ";\n            ", ";\n\n            input {\n              top: 0;\n              left: 0;\n              width: 100%;\n              cursor: inherit;\n              height: 100%;\n              margin: 0;\n              opacity: 0;\n              padding: 0;\n              position: absolute;\n            }\n\n            [data-checkmark] {\n              height: ", ";\n              width: ", ";\n              pointer-events: none;\n              transform: scale(0);\n              transform-origin: center;\n              color: ", ";\n              ", ";\n            }\n\n            &[aria-checked='true'] {\n              background-color: ", ";\n              border-color: transparent;\n\n              > svg {\n                transform: scale(1);\n              }\n            }\n\n            &:focus {\n              ", ";\n            }\n\n            &[aria-disabled] {\n              opacity: 0.6;\n            }\n\n            &[aria-invalid='true'] {\n              ", ";\n            }\n\n            &[aria-invalid='false'] {\n              ", ";\n            }\n\n            && {\n              ", "\n            }\n          "]);

  _templateObject3$2 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$5() {
  var data = _taggedTemplateLiteralLoose(["\n    &[aria-checked='true'] {\n      border-color: ", ";\n      background-color: ", ";\n    }\n\n    &:focus {\n      border-color: ", ";\n      ", ";\n    }\n  "]);

  _templateObject2$5 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$7() {
  var data = _taggedTemplateLiteralLoose(["\n          padding: 0;\n          border: 0;\n\n          &[aria-orientation='horizontal'] > [data-form-check] {\n            display: inline-flex;\n            margin-right: 1em;\n          }\n\n          && {\n            ", "\n          }\n        "]);

  _templateObject$7 = function _templateObject() {
    return data;
  };

  return data;
}

var CheckboxGroup =
/*#__PURE__*/
createComponent({
  name: 'CheckboxGroup',
  render: function render(_ref) {
    var _ref$as = _ref.as,
        As = _ref$as === void 0 ? 'fieldset' : _ref$as,
        props = _objectWithoutPropertiesLoose(_ref, ["as"]);

    return React.createElement(As, _extends({
      role: "group"
    }, props));
  },
  theme: {
    components: {
      CheckboxGroup: function CheckboxGroup(p) {
        return css(_templateObject$7(), system$1(p));
      }
    }
  },
  propTypes:
  /*#__PURE__*/
  _extends({
    children: node,
    'aria-orientation':
    /*#__PURE__*/
    oneOf(['vertical', 'horizontal']).desc('Specify the orientation of the checkbox group.')
  },
  /*#__PURE__*/
  getSystemPropTypes(system$1))
});

var validationStyle = function validationStyle(color) {
  return function (p) {
    return css(_templateObject2$5(), color, color, color, p.theme.mixins.controlFocus(color)(p))(p);
  };
};

var noop = function noop() {};

var BaseCheckbox =
/*#__PURE__*/
React.forwardRef(function BaseCheckbox(_ref2, ref) {
  var type = _ref2.type,
      checked = _ref2.checked,
      disabled = _ref2.disabled,
      id = _ref2.id,
      name = _ref2.name,
      value = _ref2.value,
      props = _objectWithoutPropertiesLoose(_ref2, ["type", "checked", "disabled", "id", "name", "value"]);

  var inputRef = React.useRef();
  var handleInputFocus = React.useCallback(function () {
    inputRef.current.parentElement.focus();
  }, []);
  return React.createElement("div", _extends({
    ref: ref
  }, props), React.createElement("input", {
    ref: inputRef,
    tabIndex: -1,
    type: type,
    checked: checked,
    disabled: disabled,
    id: id,
    name: name,
    value: value,
    onChange: noop,
    onFocus: handleInputFocus
  }), React.createElement("svg", {
    "data-checkmark": true,
    viewBox: "0 0 512 512"
  }, React.createElement("path", {
    fill: "currentColor",
    d: "M173.898 439.404l-166.4-166.4c-9.997-9.997-9.997-26.206 0-36.204l36.203-36.204c9.997-9.998 26.207-9.998 36.204 0L192 312.69 432.095 72.596c9.997-9.997 26.207-9.997 36.204 0l36.203 36.204c9.997 9.997 9.997 26.206 0 36.204l-294.4 294.401c-9.998 9.997-26.207 9.997-36.204-.001z"
  })));
});
var Checkbox =
/*#__PURE__*/
createComponent({
  name: 'Checkbox',
  render: function render(_ref3) {
    var _ref3$as = _ref3.as,
        as = _ref3$as === void 0 ? BaseCheckbox : _ref3$as,
        props = _objectWithoutPropertiesLoose(_ref3, ["as"]);

    var controlProps = useFormGroupControlProps(props);
    return React.createElement(Checkbox$1, _extends({
      as: as
    }, controlProps));
  },
  theme: [theme, formTheme, {
    sizes: {
      checkbox: {
        container: {
          xs: '10rpx',
          sm: '12rpx',
          base: '16rpx',
          lg: '22rpx',
          xl: '28rpx'
        },
        checkmark: {
          xs: '6rpx',
          sm: '8rpx',
          base: '10rpx',
          lg: '14rpx',
          xl: '18rpx'
        }
      }
    },
    components: {
      Checkbox: function Checkbox(p) {
        var scale = p.scale || 'base';
        var validColor = th.color('form.valid')(p);
        var invalidColor = th.color('form.invalid')(p);
        var containerSize = th.size("checkbox.container." + scale)(p);
        var checkmarkSize = th.size("checkbox.checkmark." + scale)(p);
        return css(_templateObject3$2(), containerSize, containerSize, th.zIndex('control')(p), th.color('formControl.background')(p), th.radius(scale)(p), th.borderWidth("formControl." + scale)(p), th.color('formControl.border')(p), safeTransition('base')(p), checkmarkSize, checkmarkSize, th.color('white')(p), safeTransition('base')(p), th.color('primary')(p), p.theme.mixins.controlFocus(th.color('primary')(p))(p), validationStyle(invalidColor)(p), validationStyle(validColor)(p), system$1(p));
      }
    }
  }],
  propTypes:
  /*#__PURE__*/
  _extends({
    checked:
    /*#__PURE__*/
    bool.desc("Checkbox's checked state. If present, it's used instead of state."),
    disabled:
    /*#__PURE__*/
    bool.desc('Same as the HTML attribute.'),
    focusable:
    /*#__PURE__*/
    bool.desc('When an element is `disabled`, it may still be `focusable`. It works similarly to `readOnly` on form elements. In this case, only `aria-disabled` will be set.'),
    onChange:
    /*#__PURE__*/
    func.desc('Same as the "checkbox" `onChange` prop.'),
    scale:
    /*#__PURE__*/
    oneOf(SCALES).desc('Control the size of the component.').defaultTo('base')
  },
  /*#__PURE__*/
  getSystemPropTypes(system$1))
});

function _templateObject$8() {
  var data = _taggedTemplateLiteralLoose(["\n            border: 0;\n            border-top: 0.0625rem solid rgba(0, 0, 0, 0.125);\n\n            && {\n              ", "\n            }\n          "]);

  _templateObject$8 = function _templateObject() {
    return data;
  };

  return data;
}

var Separator =
/*#__PURE__*/
createComponent({
  name: 'Separator',
  render: function render(props) {
    return React.createElement(Separator$1, props);
  },
  theme: [theme, {
    components: {
      Separator: function Separator(p) {
        return css(_templateObject$8(), system$1(p));
      }
    }
  }],
  propTypes:
  /*#__PURE__*/
  _extends({
    children: node,
    orientation:
    /*#__PURE__*/
    oneOf(['horizontal', 'vertical'])
  },
  /*#__PURE__*/
  getSystemPropTypes(system$1))
});

function _templateObject2$6() {
  var data = _taggedTemplateLiteralLoose(["\n            display: block;\n            appearance: none;\n            width: 100%;\n            z-index: ", ";\n            font-family: ", ";\n            font-size: ", ";\n            border-width: ", ";\n            border-color: ", ";\n            border-style: solid;\n            line-height: ", ";\n            color: ", ";\n            background-color: ", ";\n            padding: ", " ", ";\n            line-height: ", ";\n            border-radius: ", ";\n            ", ";\n\n            &[type='number'] {\n              padding-right: 6rpx;\n            }\n\n            &::placeholder {\n              color: ", ";\n            }\n\n            &:disabled {\n              background-color: ", ";\n              color: ", ";\n            }\n\n            &:focus {\n              ", "\n            }\n\n            &[aria-invalid='true'] {\n              ", ";\n            }\n\n            &[aria-invalid='false'] {\n              ", ";\n            }\n\n            && {\n              ", ";\n            }\n          "]);

  _templateObject2$6 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$9() {
  var data = _taggedTemplateLiteralLoose(["\n    border-color: ", ";\n\n    &:focus {\n      border-color: ", ";\n      ", "\n    }\n  "]);

  _templateObject$9 = function _templateObject() {
    return data;
  };

  return data;
}

var validationStyle$1 = function validationStyle(color) {
  return function (p) {
    return css(_templateObject$9(), color, color, p.theme.mixins.controlFocus(color)(p))(p);
  };
};

var Input =
/*#__PURE__*/
createComponent({
  name: 'Input',
  render: function render(_ref) {
    var _ref$as = _ref.as,
        As = _ref$as === void 0 ? 'input' : _ref$as,
        props = _objectWithoutPropertiesLoose(_ref, ["as"]);

    var controlProps = useFormControlProps(props);
    return React.createElement(As, controlProps);
  },
  theme: [theme, formTheme, {
    components: {
      Input: function Input(p) {
        var scale = p.scale || 'base';
        var px = th.space("textFormControl.x." + scale)(p);
        var py = th.space("textFormControl.y." + scale)(p);
        var validColor = th.color('form.valid')(p);
        var invalidColor = th.color('form.invalid')(p);
        return css(_templateObject2$6(), th.zIndex('control')(p), th.font('base')(p), th.fontSize(scale)(p), th.borderWidth("formControl." + scale)(p), th.color('formControl.border')(p), th.lineHeight("formControl." + scale)(p), th.color('formControl.text')(p), th.color('formControl.background')(p), py, px, th.lineHeight("button." + scale)(p), th.radius(scale)(p), safeTransition('base')(p), th.color('formControl.placeholder')(p), th.color('formControl.disabled.background')(p), th.color('formControl.disabled.text')(p), p.theme.mixins.controlFocus(th.color('primary')(p))(p), validationStyle$1(invalidColor)(p), validationStyle$1(validColor)(p), system$1(p));
      }
    }
  }],
  propTypes:
  /*#__PURE__*/
  _extends({
    children: node,
    disabled: bool,
    scale:
    /*#__PURE__*/
    oneOf(SCALES)
  },
  /*#__PURE__*/
  getSystemPropTypes(system$1))
});

function _templateObject2$7() {
  var data = _taggedTemplateLiteralLoose(["\n            appearance: none;\n            background-color: transparent;\n            padding: 8rpx;\n            border: 0;\n            border-radius: ", ";\n            color: ", ";\n            font-size: 14rpx;\n            display: block;\n            width: 100%;\n            text-align: left;\n            transition: ", ";\n            transition-property: background-color;\n            cursor: pointer;\n            /* For links */\n            text-decoration: none;\n\n            &[type='button'] {\n              appearance: none;\n            }\n\n            &:focus,\n            &:hover {\n              outline: none;\n              background-color: ", ";\n            }\n\n            &[disabled],\n            &[aria-disabled='true'] {\n              color: ", ";\n              cursor: default;\n\n              &:hover {\n                background-color: transparent;\n              }\n            }\n          "]);

  _templateObject2$7 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$a() {
  var data = _taggedTemplateLiteralLoose(["\n            border: 0.0625rem solid;\n            border-color: ", ";\n            font-family: ", ";\n            background-color: ", ";\n            border-radius: ", ";\n            padding: 0.5rem 0.25rem;\n            z-index: 999;\n\n            &:focus {\n              outline: none;\n            }\n\n            &[data-animated='true'] {\n              transition: ", ";\n              transition-property: opacity;\n              display: block !important;\n\n              &[hidden][data-animating='false'] {\n                display: none !important;\n              }\n\n              &[hidden],\n              &[data-animating='true']:not([hidden]) {\n                opacity: 0;\n              }\n\n              &:not([hidden]),\n              &[hidden][data-animating='true'] {\n                opacity: 1;\n              }\n            }\n          "]);

  _templateObject$a = function _templateObject() {
    return data;
  };

  return data;
}

var Menu =
/*#__PURE__*/
createComponent({
  name: 'Menu',
  render: function render(props) {
    return React.createElement(Menu$1, _extends({
      "data-animated": props.unstable_animated,
      "data-animating": props.unstable_animating
    }, props));
  },
  theme: [theme, {
    components: {
      Menu: function Menu(p) {
        return css(_templateObject$a(), th.color('highlightBorder')(p), th.font('base')(p), th.color('lighter')(p), th.radius('base')(p), th.transition('base')(p));
      }
    }
  }],
  propTypes:
  /*#__PURE__*/
  _extends({
    children: node
  },
  /*#__PURE__*/
  getSystemPropTypes(system$1))
});
var MenuItem =
/*#__PURE__*/
createComponent({
  name: 'MenuItem',
  render: function render(props) {
    return React.createElement(MenuItem$1, props);
  },
  theme: [theme, {
    components: {
      MenuItem: function MenuItem(p) {
        return css(_templateObject2$7(), th.radius('base')(p), th.color('light700')(p), th.transition('base')(p), th.color('highlightBackground')(p), th.color('light500')(p));
      }
    }
  }],
  propTypes:
  /*#__PURE__*/
  _extends({
    children: node
  },
  /*#__PURE__*/
  getSystemPropTypes(system$1))
});
var MenuItemDisclosure =
/*#__PURE__*/
React.forwardRef(function (props, ref) {
  return React.createElement(MenuItem, _extends({
    as: "div"
  }, props, {
    ref: ref
  }));
});
var MenuDisclosure =
/*#__PURE__*/
createComponent({
  name: 'MenuDisclosure',
  theme: theme,
  render: function render(_ref) {
    var asProp = _ref.as,
        props = _objectWithoutPropertiesLoose(_ref, ["as"]);

    var as = asProp || (props.role === 'menuitem' ? MenuItemDisclosure : Button);
    return React.createElement(MenuDisclosure$1, _extends({
      as: as
    }, props));
  },
  propTypes: Button.propTypes
});
var MenuSeparator =
/*#__PURE__*/
createComponent({
  name: 'MenuSeparator',
  theme: theme,
  render: function render(_ref2) {
    var _ref2$as = _ref2.as,
        as = _ref2$as === void 0 ? Separator : _ref2$as,
        props = _objectWithoutPropertiesLoose(_ref2, ["as"]);

    return React.createElement(MenuSeparator$1, _extends({
      as: as
    }, props));
  },
  propTypes: Separator.propTypes
});

function _templateObject$b() {
  var data = _taggedTemplateLiteralLoose(["\n  ", "\n\n  html, body {\n    font-family: ", ";\n    -webkit-font-smoothing: antialiased;\n  }\n\n  * {\n    box-sizing: border-box;\n  }\n"]);

  _templateObject$b = function _templateObject() {
    return data;
  };

  return data;
}

var Normalize =
/*#__PURE__*/
createGlobalStyle(
/*#__PURE__*/
_templateObject$b(),
/*#__PURE__*/
normalize(), fonts.base);

function _templateObject3$3() {
  var data = _taggedTemplateLiteralLoose(["\n            display: inline-flex;\n            align-items: center;\n            justify-content: center;\n            position: relative;\n            width: ", ";\n            height: ", ";\n            z-index: ", ";\n            background-color: ", ";\n            border-radius: 50%;\n            border-style: solid;\n            border-width: ", ";\n            border-color: ", ";\n            ", ";\n\n            & > input {\n              top: 0;\n              left: 0;\n              width: 100%;\n              cursor: inherit;\n              height: 100%;\n              margin: 0;\n              opacity: 0;\n              padding: 0;\n              position: absolute;\n            }\n\n            & > [data-checkmark] {\n              height: ", ";\n              width: ", ";\n              pointer-events: none;\n              transform: scale(0);\n              transform-origin: center;\n              border-radius: 50%;\n              background-color: ", ";\n              ", ";\n            }\n\n            &[aria-checked='true'] > [data-checkmark] {\n              transform: scale(1);\n            }\n\n            &:focus {\n              ", ";\n            }\n\n            &[aria-disabled] {\n              opacity: 0.6;\n            }\n\n            &[aria-invalid='true'] {\n              ", ";\n            }\n\n            &[aria-invalid='false'] {\n              ", ";\n            }\n\n            && {\n              ", "\n            }\n          "]);

  _templateObject3$3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$8() {
  var data = _taggedTemplateLiteralLoose(["\n    &[aria-checked='true'] {\n      border-color: ", ";\n      background-color: ", ";\n    }\n\n    &:focus {\n      border-color: ", ";\n      ", ";\n    }\n  "]);

  _templateObject2$8 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$c() {
  var data = _taggedTemplateLiteralLoose(["\n          padding: 0;\n          border: 0;\n\n          &[aria-orientation='horizontal'] > [data-form-check] {\n            display: inline-flex;\n            margin-right: 1em;\n          }\n\n          && {\n            ", "\n          }\n        "]);

  _templateObject$c = function _templateObject() {
    return data;
  };

  return data;
}

var RadioGroup =
/*#__PURE__*/
createComponent({
  name: 'RadioGroup',
  render: function render(props) {
    return React.createElement(RadioGroup$1, props);
  },
  theme: {
    components: {
      RadioGroup: function RadioGroup(p) {
        return css(_templateObject$c(), system$1(p));
      }
    }
  },
  propTypes:
  /*#__PURE__*/
  _extends({
    children: node,
    'aria-orientation':
    /*#__PURE__*/
    oneOf(['vertical', 'horizontal']).desc('Specify the orientation of the radio group.')
  },
  /*#__PURE__*/
  getSystemPropTypes(system$1))
});

var validationStyle$2 = function validationStyle(color) {
  return function (p) {
    return css(_templateObject2$8(), color, color, color, p.theme.mixins.controlFocus(color)(p))(p);
  };
};

var noop$1 = function noop() {};

var BaseRadio =
/*#__PURE__*/
React.forwardRef(function BaseRadio(_ref, ref) {
  var type = _ref.type,
      checked = _ref.checked,
      disabled = _ref.disabled,
      id = _ref.id,
      name = _ref.name,
      value = _ref.value,
      props = _objectWithoutPropertiesLoose(_ref, ["type", "checked", "disabled", "id", "name", "value"]);

  var inputRef = React.useRef();
  var handleInputFocus = React.useCallback(function () {
    inputRef.current.parentElement.focus();
  }, []);
  return React.createElement("div", _extends({
    ref: ref
  }, props), React.createElement("input", {
    ref: inputRef,
    tabIndex: -1,
    type: type,
    checked: checked,
    disabled: disabled,
    id: id,
    onChange: noop$1,
    name: name,
    value: value,
    onFocus: handleInputFocus
  }), React.createElement("div", {
    "data-checkmark": true
  }));
});
var Radio =
/*#__PURE__*/
createComponent({
  name: 'Radio',
  render: function render(_ref2) {
    var _ref2$as = _ref2.as,
        as = _ref2$as === void 0 ? BaseRadio : _ref2$as,
        props = _objectWithoutPropertiesLoose(_ref2, ["as"]);

    var controlProps = useFormGroupControlProps(props);
    return React.createElement(Radio$1, _extends({
      as: as
    }, controlProps));
  },
  theme: [theme, formTheme, {
    sizes: {
      radio: {
        container: {
          xs: '10rpx',
          sm: '12rpx',
          base: '16rpx',
          lg: '22rpx',
          xl: '28rpx'
        },
        checkmark: {
          xs: '6rpx',
          sm: '8rpx',
          base: '10rpx',
          lg: '14rpx',
          xl: '18rpx'
        }
      }
    },
    components: {
      Radio: function Radio(p) {
        var scale = p.scale || 'base';
        var validColor = th.color('form.valid')(p);
        var invalidColor = th.color('form.invalid')(p);
        var containerSize = th.size("radio.container." + scale)(p);
        var checkmarkSize = th.size("radio.checkmark." + scale)(p);
        return css(_templateObject3$3(), containerSize, containerSize, th.zIndex('control')(p), th.color('formControl.background')(p), th.borderWidth("formControl." + scale)(p), th.color('formControl.border')(p), safeTransition('base')(p), checkmarkSize, checkmarkSize, th.color('primary')(p), safeTransition('base')(p), p.theme.mixins.controlFocus(th.color('primary')(p))(p), validationStyle$2(invalidColor)(p), validationStyle$2(validColor)(p), system$1(p));
      }
    }
  }],
  propTypes:
  /*#__PURE__*/
  _extends({
    checked:
    /*#__PURE__*/
    bool.desc('Same as the `checked` attribute.'),
    disabled:
    /*#__PURE__*/
    bool.desc('Same as the HTML attribute.'),
    focusable:
    /*#__PURE__*/
    bool.desc('When an element is `disabled`, it may still be `focusable`. It works similarly to `readOnly` on form elements. In this case, only `aria-disabled` will be set.'),
    stopId:
    /*#__PURE__*/
    string.desc('Element ID.'),
    value:
    /*#__PURE__*/
    any.desc('Same as the value attribute.'),
    scale:
    /*#__PURE__*/
    oneOf(SCALES)
  },
  /*#__PURE__*/
  getSystemPropTypes(system$1))
});

function _templateObject2$9() {
  var data = _taggedTemplateLiteralLoose(["\n            display: block;\n            appearance: none;\n            width: 100%;\n            z-index: ", ";\n            font-family: ", ";\n            font-size: ", ";\n            border-width: ", ";\n            border-color: ", ";\n            border-style: solid;\n            line-height: ", ";\n            color: ", ";\n            background-color: ", ";\n            background: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 4 5'%3e%3cpath fill='%23343a40' d='M2 0L0 2h4zm0 5L0 3h4z'/%3e%3c/svg%3e\")\n              no-repeat right 0.75rem center/8px 10px;\n            padding: ", " ", ";\n            line-height: ", ";\n            border-radius: ", ";\n            ", ";\n\n            &::placeholder {\n              color: ", ";\n            }\n\n            &:disabled {\n              background-color: ", ";\n              color: ", ";\n            }\n\n            &:focus {\n              ", "\n            }\n\n            &[aria-invalid='true'] {\n              ", ";\n            }\n\n            &[aria-invalid='false'] {\n              ", ";\n            }\n\n            && {\n              ", "\n            }\n          "]);

  _templateObject2$9 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$d() {
  var data = _taggedTemplateLiteralLoose(["\n    border-color: ", ";\n\n    &:focus {\n      border-color: ", ";\n      ", "\n    }\n  "]);

  _templateObject$d = function _templateObject() {
    return data;
  };

  return data;
}

var validationStyle$3 = function validationStyle(color) {
  return function (p) {
    return css(_templateObject$d(), color, color, p.theme.mixins.controlFocus(color)(p))(p);
  };
};

var Select =
/*#__PURE__*/
createComponent({
  name: 'Select',
  render: function render(_ref) {
    var _ref$as = _ref.as,
        As = _ref$as === void 0 ? 'select' : _ref$as,
        props = _objectWithoutPropertiesLoose(_ref, ["as"]);

    var controlProps = useFormControlProps(props);
    return React.createElement(As, controlProps);
  },
  theme: [theme, formTheme, {
    components: {
      Select: function Select(p) {
        var scale = p.scale || 'base';
        var px = th.space("textFormControl.x." + scale)(p);
        var py = th.space("textFormControl.y." + scale)(p);
        var validColor = th.color('form.valid')(p);
        var invalidColor = th.color('form.invalid')(p);
        return css(_templateObject2$9(), th.zIndex('control')(p), th.font('base')(p), th.fontSize(scale)(p), th.borderWidth("formControl." + scale)(p), th.color('formControl.border')(p), th.lineHeight("formControl." + scale)(p), th.color('formControl.text')(p), th.color('formControl.background')(p), py, px, th.lineHeight("formControl." + scale)(p), th.radius(scale)(p), safeTransition('base')(p), th.color('formControl.placeholder')(p), th.color('formControl.disabled.background')(p), th.color('formControl.disabled.text')(p), p.theme.mixins.controlFocus(th.color('primary')(p))(p), validationStyle$3(invalidColor)(p), validationStyle$3(validColor)(p), system$1(p));
      }
    }
  }],
  propTypes:
  /*#__PURE__*/
  _extends({
    children: node,
    disabled: bool,
    scale:
    /*#__PURE__*/
    oneOf(SCALES)
  },
  /*#__PURE__*/
  getSystemPropTypes(system$1))
});

function _templateObject12() {
  var data = _taggedTemplateLiteralLoose(["\n            font-family: ", ";\n            ", "\n            ", "\n\n            && {\n              ", "\n            }\n          "]);

  _templateObject12 = function _templateObject12() {
    return data;
  };

  return data;
}

function _templateObject11() {
  var data = _taggedTemplateLiteralLoose(["\n            font-weight: 300;\n            font-size: 3.5rem;\n            margin-top: 0;\n            margin-bottom: 0.4em;\n          "]);

  _templateObject11 = function _templateObject11() {
    return data;
  };

  return data;
}

function _templateObject10() {
  var data = _taggedTemplateLiteralLoose(["\n            font-weight: 300;\n            font-size: 4.4rem;\n            margin-top: 0;\n            margin-bottom: 0.4em;\n          "]);

  _templateObject10 = function _templateObject10() {
    return data;
  };

  return data;
}

function _templateObject9() {
  var data = _taggedTemplateLiteralLoose(["\n            font-weight: 300;\n            font-size: 5.5rem;\n            margin-top: 0;\n            margin-bottom: 0.4em;\n          "]);

  _templateObject9 = function _templateObject9() {
    return data;
  };

  return data;
}

function _templateObject8() {
  var data = _taggedTemplateLiteralLoose(["\n            font-weight: 300;\n            font-size: 6rem;\n            margin-top: 0;\n            margin-bottom: 0.4em;\n          "]);

  _templateObject8 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7$1() {
  var data = _taggedTemplateLiteralLoose(["\n            font-weight: 600;\n            font-size: 1rem;\n            margin-top: 0;\n            margin-bottom: 0.4em;\n          "]);

  _templateObject7$1 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6$2() {
  var data = _taggedTemplateLiteralLoose(["\n            font-weight: 600;\n            font-size: 1.25rem;\n            margin-top: 0;\n            margin-bottom: 0.4em;\n          "]);

  _templateObject6$2 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5$2() {
  var data = _taggedTemplateLiteralLoose(["\n            font-weight: 600;\n            font-size: 1.5rem;\n            margin-top: 0;\n            margin-bottom: 0.4em;\n          "]);

  _templateObject5$2 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4$2() {
  var data = _taggedTemplateLiteralLoose(["\n            font-weight: 600;\n            font-size: 1.75rem;\n            margin-top: 0;\n            margin-bottom: 0.4em;\n          "]);

  _templateObject4$2 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3$4() {
  var data = _taggedTemplateLiteralLoose(["\n            font-weight: 600;\n            font-size: 2rem;\n            margin-top: 0;\n            margin-bottom: 0.4em;\n          "]);

  _templateObject3$4 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$a() {
  var data = _taggedTemplateLiteralLoose(["\n            font-weight: bold;\n            font-size: 2.5rem;\n            margin-top: 0;\n            margin-bottom: 0.4em;\n          "]);

  _templateObject2$a = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$e() {
  var data = _taggedTemplateLiteralLoose(["\n    display: -webkit-box;\n    -webkit-line-clamp: ", ";\n    -webkit-box-orient: vertical;\n    overflow: hidden;\n    white-space: normal;\n  "]);

  _templateObject$e = function _templateObject() {
    return data;
  };

  return data;
}

function ellipsis(_ref) {
  var _ref$lines = _ref.lines,
      lines = _ref$lines === void 0 ? Infinity : _ref$lines;
  if (lines === Infinity) return null;
  return css(_templateObject$e(), lines);
}

var system =
/*#__PURE__*/
compose(space$1, typography);
var TEXT_VARIANTS = ['h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'display-1', 'display-2', 'display-3', 'display-4'];
var Text =
/*#__PURE__*/
createComponent({
  name: 'Text',
  render: function render(_ref2, _ref3) {
    var asProp = _ref2.as,
        ref = _ref2.ref,
        _ref2$lines = _ref2.lines,
        lines = _ref2$lines === void 0 ? Infinity : _ref2$lines,
        props = _objectWithoutPropertiesLoose(_ref2, ["as", "ref", "lines"]);

    var theme = _ref3.theme,
        variant = _ref3.variant;
    var variantConfig = variant ? theme.texts[variant] : null;
    var As = asProp || variantConfig && variantConfig.defaultAs || 'span';
    var localRef = React.useRef();

    var _React$useState = React.useState(null),
        height = _React$useState[0],
        setHeight = _React$useState[1];

    React.useLayoutEffect(function () {
      if (!window.getComputedStyle || lines === Infinity) return;
      var style = window.getComputedStyle(localRef.current);
      var lineHeight = parseInt(style.lineHeight, 10);
      var height = lineHeight / 16 * lines;
      setHeight(height + "rem");
    }, [lines]);
    return React.createElement(As, _extends({
      ref: mergeRefs([ref, localRef]),
      style: _extends({
        height: height
      }, props.style)
    }, props));
  },
  theme: [theme, {
    texts: {
      h1: {
        defaultAs: 'h1',
        style:
        /*#__PURE__*/
        css(
        /*#__PURE__*/
        _templateObject2$a())
      },
      h2: {
        defaultAs: 'h2',
        style:
        /*#__PURE__*/
        css(
        /*#__PURE__*/
        _templateObject3$4())
      },
      h3: {
        defaultAs: 'h3',
        style:
        /*#__PURE__*/
        css(
        /*#__PURE__*/
        _templateObject4$2())
      },
      h4: {
        defaultAs: 'h4',
        style:
        /*#__PURE__*/
        css(
        /*#__PURE__*/
        _templateObject5$2())
      },
      h5: {
        defaultAs: 'h5',
        style:
        /*#__PURE__*/
        css(
        /*#__PURE__*/
        _templateObject6$2())
      },
      h6: {
        defaultAs: 'h6',
        style:
        /*#__PURE__*/
        css(
        /*#__PURE__*/
        _templateObject7$1())
      },
      'display-1': {
        defaultAs: 'h1',
        style:
        /*#__PURE__*/
        css(
        /*#__PURE__*/
        _templateObject8())
      },
      'display-2': {
        defaultAs: 'h2',
        style:
        /*#__PURE__*/
        css(
        /*#__PURE__*/
        _templateObject9())
      },
      'display-3': {
        defaultAs: 'h3',
        style:
        /*#__PURE__*/
        css(
        /*#__PURE__*/
        _templateObject10())
      },
      'display-4': {
        defaultAs: 'h4',
        style:
        /*#__PURE__*/
        css(
        /*#__PURE__*/
        _templateObject11())
      }
    },
    components: {
      Text: function Text(p) {
        var variantConfig = p.variant ? p.theme.texts[p.variant] : null;
        return css(_templateObject12(), th.font('base')(p), ellipsis(p), variantConfig ? variantConfig.style : null, system(p));
      }
    }
  }],
  propTypes:
  /*#__PURE__*/
  _extends({
    children: node,
    lines:
    /*#__PURE__*/
    number.desc('Control the number of lines to display'),
    variants:
    /*#__PURE__*/
    oneOfType([oneOf(TEXT_VARIANTS), string]).defaultTo('primary').desc('Control the color variant of the component.')
  },
  /*#__PURE__*/
  getSystemPropTypes(system))
});
var InnerTextarea =
/*#__PURE__*/
createInnerComponent({
  name: 'Textarea',
  render: function render(_ref) {
    var _ref$as = _ref.as,
        As = _ref$as === void 0 ? 'textarea' : _ref$as,
        props = _objectWithoutPropertiesLoose(_ref, ["as"]);

    var controlProps = useFormControlProps(props);
    return React.createElement(As, _extends({}, props, controlProps));
  }
});
var Textarea =
/*#__PURE__*/
Input.withComponent(InnerTextarea);
Textarea.propTypes = Input.propTypes;

function _templateObject$f() {
  var data = _taggedTemplateLiteralLoose(["\n            display: inline-block;\n            position: relative;\n            z-index: ", ";\n            font-family: ", ";\n            border-radius: ", ";\n            width: ", ";\n            height: ", ";\n            background-color: ", ";\n            overflow: hidden;\n            cursor: pointer;\n            border-width: ", ";\n            border-color: ", ";\n            border-style: solid;\n            font-size: ", ";\n            font-weight: ", ";\n            ", ";\n\n            input {\n              top: 0;\n              left: 0;\n              width: 100%;\n              cursor: inherit;\n              height: 100%;\n              margin: 0;\n              opacity: 0;\n              padding: 0;\n              position: absolute;\n              z-index: 1;\n            }\n\n            [data-switch-content] {\n              display: flex;\n              align-items: center;\n              height: 100%;\n              pointer-events: none;\n              ", ";\n            }\n\n            [data-switch-ball] {\n              flex-shrink: 0;\n              background-color: ", ";\n              border-radius: 50%;\n              width: ", ";\n              height: ", ";\n              margin: 0 6%;\n              ", ";\n            }\n\n            [data-switch-label] {\n              position: absolute;\n              width: calc(", " / 2);\n              text-align: center;\n              line-height: ", ";\n              user-select: none;\n              overflow: hidden;\n            }\n\n            [data-switch-label='on'] {\n              left: -50%;\n              color: ", ";\n            }\n\n            [data-switch-label='off'] {\n              right: 0;\n              color: ", ";\n            }\n\n            &:focus {\n              ", ";\n            }\n\n            &[aria-checked='true'] {\n              background-color: ", ";\n              border-color: transparent;\n\n              [data-switch-content] {\n                transform: translateX(calc(", " - ", " - 12%));\n              }\n\n              [data-switch-ball] {\n                background-color: ", ";\n              }\n            }\n\n            &[aria-disabled='true'] {\n              opacity: 0.6;\n            }\n\n            && {\n              ", "\n            }\n          "]);

  _templateObject$f = function _templateObject() {
    return data;
  };

  return data;
}

var noop$2 = function noop() {};

var BaseSwitch =
/*#__PURE__*/
React.forwardRef(function BaseSwitch(_ref, ref) {
  var labeled = _ref.labeled,
      _ref$onLabel = _ref.onLabel,
      onLabel = _ref$onLabel === void 0 ? 'ON' : _ref$onLabel,
      _ref$offLabel = _ref.offLabel,
      offLabel = _ref$offLabel === void 0 ? 'OFF' : _ref$offLabel,
      type = _ref.type,
      checked = _ref.checked,
      disabled = _ref.disabled,
      id = _ref.id,
      name = _ref.name,
      value = _ref.value,
      props = _objectWithoutPropertiesLoose(_ref, ["labeled", "onLabel", "offLabel", "type", "checked", "disabled", "id", "name", "value"]);

  var inputRef = React.useRef();
  var handleInputFocus = React.useCallback(function () {
    inputRef.current.parentElement.focus();
  }, []);
  return React.createElement("div", _extends({
    ref: ref
  }, props), React.createElement("div", {
    "data-switch-content": true
  }, labeled && React.createElement("div", {
    "data-switch-label": "on"
  }, onLabel), React.createElement("div", {
    "data-switch-ball": true
  }), labeled && React.createElement("div", {
    "data-switch-label": "off"
  }, offLabel)), React.createElement("input", {
    ref: inputRef,
    tabIndex: -1,
    type: type,
    checked: checked,
    disabled: disabled,
    id: id,
    name: name,
    value: value,
    onChange: noop$2,
    onFocus: handleInputFocus
  }));
});
var Switch =
/*#__PURE__*/
createComponent({
  name: 'Switch',
  render: function render(_ref2) {
    var _ref2$as = _ref2.as,
        as = _ref2$as === void 0 ? BaseSwitch : _ref2$as,
        scale = _ref2.scale,
        props = _objectWithoutPropertiesLoose(_ref2, ["as", "scale"]);

    var controlProps = useFormGroupControlProps(props);
    return React.createElement(Checkbox$1, _extends({
      as: as
    }, controlProps));
  },
  theme: [theme, formTheme, {
    fontSizes: {
      "switch": {
        xs: '2rpx',
        sm: '5rpx',
        base: '9rpx',
        lg: '12rpx',
        xl: '18rpx'
      }
    },
    sizes: {
      "switch": {
        container: {
          width: {
            xs: '24rpx',
            sm: '32rpx',
            base: '48rpx',
            lg: '72rpx',
            xl: '108rpx'
          },
          height: {
            xs: '12rpx',
            sm: '16rpx',
            base: '24rpx',
            lg: '36rpx',
            xl: '54rpx'
          },
          ball: {
            xs: '8rpx',
            sm: '12rpx',
            base: '18rpx',
            lg: '28rpx',
            xl: '40rpx'
          }
        }
      }
    },
    components: {
      Switch: function Switch(p) {
        var scale = p.scale || 'base';
        var width = th.size("switch.container.width." + scale)(p);
        var height = th.size("switch.container.height." + scale)(p);
        var ballSize = th.size("switch.container.ball." + scale)(p);
        return css(_templateObject$f(), th.zIndex('control')(p), th.font('base')(p), th.radius('34rpx')(p), width, height, th.color('light300')(p), th.borderWidth("formControl.base")(p), th.color('formControl.border')(p), th.fontSize("switch." + scale)(p), th.fontWeight('extraBold')(p), safeTransition('base')(p), safeTransition('base')(p), th.color('light500')(p), ballSize, ballSize, safeTransition('base')(p), width, height, th.color('primary')(p), th.color('gray900')(p), p.theme.mixins.controlFocus(th.color('primary')(p))(p), lighten(0.3, th.color('primary')(p)), width, ballSize, th.color('primary')(p), system$1(p));
      }
    }
  }],
  propTypes:
  /*#__PURE__*/
  _extends({
    checked:
    /*#__PURE__*/
    bool.desc("Checkbox's checked state. If present, it's used instead of state."),
    disabled:
    /*#__PURE__*/
    bool.desc('Same as the HTML attribute.'),
    focusable:
    /*#__PURE__*/
    bool.desc('When an element is `disabled`, it may still be `focusable`. It works similarly to `readOnly` on form elements. In this case, only `aria-disabled` will be set.'),
    onChange:
    /*#__PURE__*/
    func.desc('Same as the "checkbox" `onChange` prop.'),
    scale:
    /*#__PURE__*/
    oneOf(SCALES).desc('Control the size of the component.').defaultTo('base')
  },
  /*#__PURE__*/
  getSystemPropTypes(system$1))
});
export { Alert, Boxer, Button, Card, CardBody, CardFooter, CardHeader, CardImg, CardText, CardTitle, Checkbox, CheckboxGroup, Form, FormCheck, FormCheckLabel, FormField, FormFieldLabel, FromGroupProvider, Input, Menu, MenuDisclosure, MenuItem, MenuSeparator, Normalize, Radio, RadioGroup, SCALES, Select, Separator, Switch, TEXT_VARIANTS, Text, Textarea, VARIANTS, colorLevel, colorYik, createComponent, createFieldsGroupContext, createInnerComponent, css, getSystemPropTypes, mergeClone, safeTransition, scale, systemProps, theme, transition, transitionEnabled, useFormControlProps, useFormGroupControlProps, useRandomId };